import { render, staticRenderFns } from "./to_do.vue?vue&type=template&id=28297684&scoped=true"
import script from "./to_do.vue?vue&type=script&lang=js"
export * from "./to_do.vue?vue&type=script&lang=js"
import style0 from "./to_do.vue?vue&type=style&index=0&id=28297684&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28297684",
  null
  
)

export default component.exports